import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";
import { getQueryClient } from "@/services/get-query-client";

export async function saveApiKey(apiKey: string) {
  try {
    const data = await authenticatedFetchJson<{ value?: string; apiKey?: string }>("/api/api-key", {
      method: "POST",
      body: JSON.stringify({ apiKey }),
    });

    // Invalidate sessions and credits queries to refetch with new API key
    const queryClient = getQueryClient();
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["sessions"] }),
      queryClient.invalidateQueries({ queryKey: ["credits"] }),
      queryClient.invalidateQueries({ queryKey: ["api-key"] }),
    ]);

    return data.value || data.apiKey || apiKey;
  } catch (error) {
    console.error("Error saving API key:", error);
    throw error;
  }
}
